import React, {useEffect} from 'react';
import useRevenueStoreMonth from './RevenueStoreM';

const RevenueChartMPro = () => {
    const totalRevenue = useRevenueStoreMonth((state) => state.totalRevenue);
    const totalCosts = useRevenueStoreMonth((state) => state.totalCosts);
    const totalYield = useRevenueStoreMonth((state) => state.totalYield);

    // Berechnung der Prozente
    const costsPercentage = totalRevenue > 0 ? ((totalCosts / totalRevenue) * 100).toFixed(2) : 0;
    const yieldPercentage = totalRevenue > 0 ? ((totalYield / totalRevenue) * 100).toFixed(2) : 0;

    useEffect(() => {
        console.log("Total Revenue:", totalRevenue);
        console.log("Total Costs:", totalCosts);
        console.log("Total Yield:", totalYield);
    }, [totalRevenue, totalCosts, totalYield]);

    return (
        <div className='flex justify-center items-center gap-2'>
            <div className='flex items-center'>
                <div className='w-2 h-2 bg-color-1 rounded-full mr-2'/>
                <div className='font-color-6'>Kosten: {costsPercentage}%</div>
            </div>
            <div className='flex items-center'>
                <div className='w-2 h-2 bg-color-4 rounded-full mr-2'/>
                <div className='font-color-6'>Rohertrag 1: {yieldPercentage}%</div>
            </div>
        </div>
    );
};

export default RevenueChartMPro;